export const GUIDS = {
  ZERO: '00000000-0000-0000-0000-000000000000',
  PAYEE_TYPE: {
    TRANSFEREE: 'c3b2c3c1-0324-4c7b-8b97-ef3f3a4a3f6e',
    VENDOR: '38c8b61e-2a18-4e3f-9c59-3a5e9b1a1d2a'
  }
};

export const VOUCHER_STATUS = {
  DRAFT: '2a9d4d3e-d1a3-4a85-9f5a-5a6f0d7cb4b5'
};

export const INTERNATIONAL_VOUCHER_TYPE_ID = '25c17294-ef8d-4c9f-9a18-8517434f9d02';
export const PAYMENT_VOUCHER_TYPE_ID = 'a4cdb2fe-420b-4a30-a3e3-9b3ec9b6c37c';
export const TRACK_VOUCHER_TYPE_ID = '8d1a6c3a-3f33-4c61-8f17-6d7a9b1c1a25';
export const FEE_VOUCHER_TYPE_ID = 'd41c9f45-38b4-4b95-a28a-77eaf3a94840';

export const USD_CURRENCY_ID = '7360B8F8-A885-4CC9-A5B1-97233FF79C75';

export const buildCreateVoucherRequest = ({
  clientId,
  payToVendor,
  vendorId,
  authorizationId,
  description = '',
  invoiceNumber = '',
  amount = null,
  expenseAnalystId = null
}) => {
  const payeeTypeId = payToVendor ? GUIDS.PAYEE_TYPE.VENDOR : GUIDS.PAYEE_TYPE.TRANSFEREE;
  return {
    addressInformation: null,
    bankingInformation: null,
    voucherLineItems: [],
    payee: {
      payeeId: null,
      payeeTypeId,
      vendorId: payToVendor ? vendorId : null,
      authorizationId: !payToVendor ? authorizationId : null,
      transfereePayeeId: null,
      vendorPayeeId: null
    },
    voucherInformation: {
      voucherId: null,
      payeeId: null,
      voucherStatusId: VOUCHER_STATUS.DRAFT,
      isSubmitToReview: false,
      clientId: clientId ?? null,
      invoiceNumber: invoiceNumber || '',
      amount: amount ?? null,
      expenseAnalystId: expenseAnalystId ?? null,
      description: description || '',
      invoiceDate: null,
      receiptCurrencyId: USD_CURRENCY_ID,
      payInCurrencyId: USD_CURRENCY_ID,
      batchTypeId: GUIDS.ZERO,
      voucherTypeId: GUIDS.ZERO,
      notPayableId: GUIDS.ZERO,
      currencyExchangeRate: null,
      currencyExchangeRateDate: null,
      onHoldReason: '',
      denyReason: '',
      entryDate: null,
      isRushPayment: false,
      dueDate: null,
      payrollDate: null,
      isWireTransfer: false,
      addedBy: 1, // TODO: Replace with actual internal user ID
      addedOn: new Date(),
      modifiedBy: 1, // TODO: Replace with actual internal user ID
      modifiedOn: new Date()
    }
  };
};

export const norm = s =>
  (s || '')
    .toString()
    .trim()
    .toLowerCase();
